import { ChangeDetectorRef, Component, Input, SimpleChanges } from '@angular/core';
import { DataService } from 'src/app/services/data.service';
import { GlobalConstants } from 'src/app/services/global-constants';
import { PermissionHandlerService } from 'src/app/services/permission-handler.service';

@Component({
  selector: 'app-all-data-view-items',
  templateUrl:'./all-data-view-items.component.html',
  styleUrl: './all-data-view-items.component.scss'
})
export class AllDataViewItemsComponent {
  isObject(arg0: any): boolean {
    return !Array.isArray(arg0)
  }
  getIcon(arg0: unknown) {
    return arg0 as string
  }
  converttostring(arg0: unknown): string {
    let res = arg0 as string

    return res;
  }
  isLoggedIn = JSON.parse(localStorage.getItem('isLoggedIn') || "false");
  layout: string = 'grid';



  @Input() filterItems!: any[]

  @Input() type: string = "جميع الكيانات والوزارات";

  @Input() gotoLink: string = '/all-data-view'

  @Input() datatype: string = 'service'
  @Input() loading: boolean = false;

  siteUrl = GlobalConstants.staticFilesURL;

  private _filterText: string = '';
  @Input() set filterText(val: string) {
    this._filterText = val || '';
    this.applyFilter();
  }
  get filterText(): string {
    return this._filterText;
  }
  notObject: any = {
    name: "notObject",
    image: "pi pi-times"
  };

  constructor(private cdr: ChangeDetectorRef,
    private dataService: DataService,
    private permissionService: PermissionHandlerService
  ) {
  }

  @Input() items: any[] = [];
  @Input() object: any;
  notcountedItems: any[] = [];

  sequence: string[] = ["الخدمات", "الأسئلة الشائعة"];

  getSortedDataCounter(item: any): Record<string, number> {
    const dataCounter = item.data_counter || {};
    return Object.entries(dataCounter)
      .sort(([keyA], [keyB]) => {
        const indexA = this.sequence.indexOf(keyA);
        const indexB = this.sequence.indexOf(keyB);
        return indexA - indexB;
      })
      .reduce((acc: any, [key, value]) => {
        acc[key] = value;
        return acc;
      }, {});
  }

  dataTypes: any = {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['items'] || changes['filterText'] || changes['object']) {
      this.applyFilter();
    }
    if (changes['object'] && changes['object'].currentValue) {
      console.log('ngOnChanges: object changed');
    }
  }

  ngOnInit(): void {
    this.getDataTypes().then((data: any) => {
      data.forEach((item: { arabic: string | number; icon: any; }) => {
        this.dataTypes[item.arabic] = item.icon;
      });
    })
    console.log('ngOnInit');
  }


  checkOuIdExists(id: string) {
    return this.permissionService.payload.dataView.signedOus.includes(id)
  }

  checkDataCountValues(data: any) {
    if (this.isLoggedIn) {
      return true;
    } else {

      if(!!data && this.checkOuIdExists(data._id)) {
        return (Object.values(data) as number[]).reduce((a, b) => a + b, 0) > 0
      }
      
      return true;
    }
  }

  ngAfterViewInit(): void {
    console.log('ngAfterViewInit');

    if (this.object && this.items) {
      this.applyFilter();
    }
  }


  //Image if its image or icon
  checkisImg(arg0: string | undefined): any {
    if (arg0) {
      return /\.(jpg|jpeg|png|gif|svg)/.test(arg0);
    } else {
      return false;
    }
  }

  // Create a method to check if an item with a specific ID and 'ous' property exists
  itemHasOus(id: number, ous: number[]): boolean {
    return ous.includes(id);
  }

  applyFilter() {
    const source = this.items || [];
    if (this.filterText && this.filterText.trim() !== '') {
      const query = this.filterText.trim().toLowerCase();
      this.filterItems = source.filter(item =>
        item.name?.toLowerCase().includes(query)
      );
    } else {
      this.filterItems = source;
    }
  }

  async getDataTypes() {
    let res = await this.dataService.postData('data-type/get?offset=10&page=1', {});

    return res.data;
  }



  consoleThis() {
    console.log("< service view >")
  }

  applyNotObject() {
    this.filterItems = this.notcountedItems
  }

  dataSorter(dataCounter: any[]): any[] {
    const orderArray = ["الخدمات", "الأسئلة الشائعة"];

    if (dataCounter) {

      // Sort the dataCounter array
      dataCounter.sort((a, b) => {
        const aIndex = orderArray.indexOf(a._id);
        const bIndex = orderArray.indexOf(b._id);

        // If both items are in the orderArray, sort based on their order
        if (aIndex !== -1 && bIndex !== -1) {
          return aIndex - bIndex;
        }

        // If only one of the items is in the orderArray, it comes first
        if (aIndex !== -1) {
          return -1;
        }
        if (bIndex !== -1) {
          return 1;
        }

        // If neither item is in the orderArray, sort them by their _id
        return a._id.localeCompare(b._id);
      });

    }

    return dataCounter; // Return the sorted array
  }

  onCardClick(item: any): void {
    if (typeof window !== 'undefined' && window.innerWidth >= 992) {
      // Only one card open at a time: opening this one closes the rest.
      this.filterItems?.forEach((other: any) => (other.expanded = other === item));
    }
  }

  getCardCounters(item: any): any[] {
    const list: any[] = [];
    if (!item) return list;
    
    let counterSource: any = null;
    
    if (this.isLoggedIn) {
      counterSource = item.data_counter;
    } else {
      if (this.checkOuIdExists(item._id)) {
        counterSource = item.data_counter_signed || item.data_counter;
      } else {
        counterSource = item.data_counter;
      }
    }
    
    if (!counterSource) return list;
    
    if (this.isObject(counterSource)) {
      Object.keys(counterSource).forEach(key => {
        list.push({
          label: key,
          count: counterSource[key],
          icon: this.dataTypes[key] || 'pi pi-globe'
        });
      });
      // Sort them using same orderArray logic
      const orderArray = ["الخدمات", "الأسئلة الشائعة"];
      list.sort((a, b) => {
        const aIndex = orderArray.indexOf(a.label);
        const bIndex = orderArray.indexOf(b.label);
        if (aIndex !== -1 && bIndex !== -1) return aIndex - bIndex;
        if (aIndex !== -1) return -1;
        if (bIndex !== -1) return 1;
        return a.label.localeCompare(b.label);
      });
    } else {
      // Array source
      const sorted = this.dataSorter(counterSource);
      if (Array.isArray(sorted)) {
        sorted.forEach(c => {
          list.push({
            label: c._id,
            count: c.count,
            icon: c.icon || 'pi pi-chart-bar'
          });
        });
      }
    }
    return list;
  }

}

